import React from 'react';
import { Helmet } from 'react-helmet-async';

const defaultSEO = {
  siteName: 'The Soul Script',
  defaultTitle: 'The Soul Script | Life Coaching & Tarot for Seekers',
  defaultDescription: 'A reflective sanctuary for seekers. Coaching as inquiry, tarot as reflection. Build emotional resilience, practise self-acceptance, and find the courage to meet yourself with honesty.',
  defaultImage: 'https://images.unsplash.com/photo-1765891597474-e290eabcb626?w=1200&q=80',
  siteUrl: 'https://www.thesoulscript.life',
};

export const SEO = ({ 
  title, 
  description, 
  image, 
  path = '',
  type = 'website'
}) => {
  const seo = {
    title: title ? `${title} | ${defaultSEO.siteName}` : defaultSEO.defaultTitle,
    description: description || defaultSEO.defaultDescription,
    image: image || defaultSEO.defaultImage,
    url: `${defaultSEO.siteUrl}${path}`,
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:site_name" content={defaultSEO.siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      
      {/* Canonical */}
      <link rel="canonical" href={seo.url} />
    </Helmet>
  );
};

// Page-specific SEO configurations
export const pageSEO = {
  home: {
    title: null, // Uses default
    description: 'A reflective sanctuary for seekers. Coaching as inquiry, tarot as reflection. Build emotional resilience and find the courage to meet yourself with honesty.',
  },
  about: {
    title: 'Philosophy',
    description: 'The Soul Script was born from lived experience—learning to build emotional resilience, practise self-acceptance, and meet life with steady presence.',
  },
  coaching: {
    title: 'Life Coaching',
    description: 'Coaching as inquiry, not instruction. Build emotional resilience, practise self-acceptance, and find the courage to meet yourself with honesty. Packages from $150.',
  },
  tarot: {
    title: 'Tarot Readings',
    description: 'Tarot as reflection, not prediction. A mirror for understanding and a practice that brings steadiness where there was once only searching. Sessions from $25.',
  },
  collective: {
    title: 'The Collective',
    description: 'Monthly tarot readings for the collective journey. Reflections on the energies, themes, and invitations of each season.',
  },
  toolkit: {
    title: 'Self Care Toolkit',
    description: 'The Soul Script Self Care Toolkit—a self-guided resource for seekers who want tools to practise reflection independently. Coming soon.',
  },
  contact: {
    title: 'Contact',
    description: 'Get in touch with The Soul Script. Questions, inquiries, or simply something on your heart. A space for respectful connection.',
  },
};
